import { auth } from '../firebase';
import { logger } from '../utils/logger';
import { getBackendUrl } from './api';

// ✅ CACHE: Cache para o modo de produção do bot (evita múltiplas chamadas ao backend)
let botProductionModeCache = null;
let botProductionModeCacheTime = 0;
const BOT_PRODUCTION_MODE_CACHE_DURATION = 60000; // 1 minuto de cache

/**
 * ✅ FUNÇÃO UTILITÁRIA: Verifica o modo de produção do bot com cache
 * @param {string} companyId - ID da empresa
 * @returns {Promise<boolean>} - true se o bot está em modo de produção
 */
export const checkBotProductionMode = async (companyId) => {
  try {
    // Verificar cache primeiro
    const now = Date.now();
    if (botProductionModeCache !== null && (now - botProductionModeCacheTime) < BOT_PRODUCTION_MODE_CACHE_DURATION) {
      logger.log('✅ [CACHE] Usando modo de produção do bot do cache:', botProductionModeCache);
      return botProductionModeCache;
    }
    
    const currentUser = auth.currentUser;
    if (!currentUser) return false;
    
    const authToken = await currentUser.getIdToken();
    // Usa a mesma resolução de base URL do restante do app
    // (REACT_APP_API_BASE_URL / runtime config / origin atual)
    const BACKEND_URL = getBackendUrl();
    const response = await fetch(
      `${BACKEND_URL}/get_bot_production_mode?companyId=${companyId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
      }
    );
    
    if (response.ok) {
      const data = await response.json();
      // Armazenar no cache
      botProductionModeCache = data.productionMode;
      botProductionModeCacheTime = now;
      logger.log('✅ [CACHE] Modo de produção do bot armazenado no cache:', botProductionModeCache);
      return data.productionMode;
    }
    return false;
  } catch (error) {
    console.error('❌ Erro ao verificar modo de produção do bot:', error);
    // Em caso de erro, usar cache se disponível
    if (botProductionModeCache !== null) {
      logger.log('⚠️ [CACHE] Usando cache devido a erro:', botProductionModeCache);
      return botProductionModeCache;
    }
    return false;
  }
};

/**
 * ✅ FUNÇÃO AUXILIAR: Limpa o cache do modo de produção
 * Útil quando houver alterações nas configurações do bot
 */
export const clearBotProductionModeCache = () => {
  botProductionModeCache = null;
  botProductionModeCacheTime = 0;
  logger.log('🧹 [CACHE] Cache do modo de produção do bot limpo');
};

